import { PropertyFilterProcessingNode } from './PropertyFilterProcessingNode';
/**
 * @category Processing node
 */
export class HPFilterNode extends PropertyFilterProcessingNode {
  constructor(propertySelector, propertyModifier, options) {
    super(propertySelector, propertyModifier, options);
  }
  initFilter(object, value, options) {
    return new Promise(resolve => {
      const rc = 1.0 / (options.cutOff * 2 * Math.PI);
      const dt = 1.0 / options.sampleRate;
      const alpha = rc / (rc + dt);
      resolve({
        x: value,
        y: value,
        alpha
      });
    });
  }
  filter(object, value, filter) {
    return new Promise(resolve => {
      if (typeof value === 'number') {
        filter.x = filter.alpha * (filter.x + value - filter.y);
        filter.y = value;
        resolve(filter.x);
      } else {
        filter.x = filter.x.clone().add(value).sub(filter.y).multiplyScalar(filter.alpha);
        filter.y = value;
        resolve(filter.x);
      }
    });
  }
}